import { useLocation } from "react-router-dom";
import { useSite } from "../../lib/site";
import { img } from "../../lib/api";
import { switchLangPath } from "../../lib/i18n";

const abs = (u) => {
  const v = img(u);
  return v && v.startsWith("/") ? window.location.origin + v : v;
};

export function Seo({ title, description, image, type = "website", jsonLd }) {
  const { site, lang, t, subtitle } = useSite();
  const { pathname } = useLocation();
  const seo = site.seo || {};
  const siteName = t(site.general?.site_name) || site.profile?.name || "";
  const full = title ? (seo.title_template || "%s | %site").replace("%site", siteName).replace("%s", title) : `${siteName} — ${subtitle}`;
  const desc = (description || t(seo.description) || "").slice(0, 160);
  const origin = window.location.origin;
  const langs = site.language?.active?.filter((l) => ["tr", "en"].includes(l)) || ["tr"];
  const ogImg = abs(image || seo.og_image);
  return (
    <>
      <title>{full}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={origin + pathname} />
      {langs.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={origin + (l === lang ? pathname : switchLangPath(pathname, lang, l))} />
      ))}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={origin + pathname} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={lang === "tr" ? "tr_TR" : "en_US"} />
      {ogImg && <meta property="og:image" content={ogImg} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={desc} />
      {ogImg && <meta name="twitter:image" content={ogImg} />}
      {seo.robots_index === false && <meta name="robots" content="noindex,nofollow" />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </>
  );
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({ "@type": "ListItem", position: i + 1, name: it.name, item: window.location.origin + it.path })),
});
